export default {
	apiKey: "AIzaSyAHynB37-CxBBk8LgNzlr5Z5IDmGkfQCGk",
	authDomain: "ayun-quantity-qa.firebaseapp.com",
	projectId: "ayun-quantity-qa",
	storageBucket: "ayun-quantity-qa.appspot.com",
	messagingSenderId: "273346470099",
	appId: "1:273346470099:web:a637cca977aea0cccc7426",
	measurementId: "G-1B0F67PMWD"
};